import { Grid, GridProps } from '@mui/material';
import { useField, useFormikContext } from 'formik';
import { FormFieldProps } from '..';
import { FileUpload, FileUploadProps, FileWithPreview } from '../../../../../atomic/input/upload';
import { FormFieldWrapper } from '../../shared/formFieldWrapper';
import { useEffect } from 'react';
import { getBase64 } from '../../../../../../util';

type FormFileUploadProps = FormFieldProps &
  Omit<FileUploadProps, 'onChange'> &
  Pick<GridProps, 'lg' | 'md' | 'sm' | 'xl' | 'xs'>;

const MAX_FILE_SIZE_FOR_BE = 100 * 1024 * 1024;

export const FormFileUpload = FormFieldWrapper<FormFileUploadProps>((props) => {
  const [, meta] = useField<string>(props.name);
  const { setFieldValue, setFieldTouched, validateForm } = useFormikContext();

  useEffect(() => {
    validateForm();
  }, [meta.value]);

  return (
    <Grid item xs={props.xs ?? 12} lg={props.lg} md={props.md} sm={props.sm} xl={props.xl}>
      <FileUpload
        {...props}
        options={{
          maxSize: MAX_FILE_SIZE_FOR_BE,
          ...props.options
        }}
        error={meta.touched && !!meta.error}
        helperText={meta.error}
        cropPhoto={props.cropPhoto}
        onChange={(acceptedFiles?: Array<FileWithPreview>) => {
          if (!acceptedFiles) {
            return setFieldValue(props.name, acceptedFiles);
          }

          const noBlobFiles = acceptedFiles.filter((file) => !(file instanceof Blob));
          const blobFiles = acceptedFiles.filter((file) => file instanceof Blob);

          const base64StringPromises = blobFiles.map(getBase64);

          Promise.all(base64StringPromises).then((base64StringFiles) => {
            const filesOutput = base64StringFiles
              .map(
                (base64String, index) =>
                  ({
                    file: base64String,
                    name: blobFiles[index].name
                  }) as FileWithPreview
              )
              .concat(noBlobFiles);

            setFieldValue(props.name, filesOutput);
            props.additionalOnChange?.(filesOutput, setFieldValue);
            setFieldTouched(props.name, true);
          });
        }}
      />
    </Grid>
  );
});
